import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { VISUALLY_HIDDEN_SX } from './visuallyHiddenSx';

type Props = {
  children: ReactNode;
  /** 外側の箱のレイアウト(flex・高さなど)。 */
  sx?: Readonly<Record<string, unknown>>;
};

/**
 * 読み込み中の知らせ。スケルトン(形だけの影)を包み、スクリーンリーダーには「読み込み中…」を 1 回だけ伝える。
 * 隠しテキストは絶対配置にして、スケルトンの位置と高さに影響させない(この箱が基準なので position: relative)。
 */
export const LoadingStatus = ({ children, sx }: Props) => (
  <Box role="status" aria-busy="true" aria-live="polite" sx={{ position: 'relative', ...sx }}>
    <Box component="span" sx={{ ...VISUALLY_HIDDEN_SX, position: 'absolute' }}>
      読み込み中…
    </Box>
    {children}
  </Box>
);
